import type { LessonListItem } from '@/types/apis/Lesson';
import type { ClassValue } from 'clsx';

import React from 'react';
import Image from 'next/image';
import Link from 'next/link';

import { cn } from '@/lib/utils';
import routes from '@/statics/routes';
import PlayIcon from '@/svgs/arrow.svg';
import Promoted from '@/svgs/fireWithBackground.svg';
import New from '@/svgs/newest.svg';

type Props = {
  className?: ClassValue;
  lesson: LessonListItem;
  hasIcon?: boolean;
};

const LandingLessonCard: React.FC<Props> = ({
  className,
  lesson,
  hasIcon = true,
}) => {
  return (
    <Link passHref href={routes.lesson.href(lesson.id.toString())}>
      <div
        className={cn(
          'w-full relative aspect-16/10 rounded-2xl overflow-hidden',
          className
        )}
      >
        {hasIcon &&
          (lesson.tag === 'newest' || lesson.tag === 'most_visited') && (
            <div className="absolute top-1 right-1 z-1 w-[28px] h-[28px]">
              {lesson.tag === 'most_visited' ? <Promoted /> : <New />}
            </div>
          )}
        <Image
          src={lesson.image || lesson.video_cover_image || ''}
          alt={lesson.title}
          fill
          sizes="(max-width: 768px) 100vw, 480px"
          className="object-cover"
          priority={false}
        />
        <div className="h-[54px] w-full absolute bottom-0">
          <div
            className="h-full w-full right-0 absolute bottom-0 
          rounded-bl-2xl rounded-br-2xl overflow-hidden"
            style={{
              background: 'rgb(69 68 68 / 10%)',
              backdropFilter: ' blur(31px)',
            }}
          />
          <div className="absolute bottom-0 w-full h-full flex items-center justify-between ps-5 pe-2 pt-2 pb-2">
            <div className="w-[calc(100%-50px)]">
              <p className="text-xs font-bold truncate text-white">
                {lesson.title}
              </p>
              <p className="text-tiny font-normal truncate text-white">
                {lesson.description}
              </p>
            </div>
            <div className="w-[41px] h-[41px] flex items-center justify-center">
              <PlayIcon />
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default LandingLessonCard;
